import { DataWarnings, PossibleDuplicatePayment } from "../../types/claims";

// The claim's dataWarnings, read the same way by the claims table and the claim preview

/** The attachment mismatch warnings, as sentences. */
export const getMismatchWarnings = (
  dataWarnings: DataWarnings | null | undefined,
): string[] => {
  if (!dataWarnings || typeof dataWarnings !== "object") return [];
  const warnings: string[] = [];
  if (dataWarnings.mrn_mismatch)
    warnings.push("MRN mismatch across attachments");
  if (dataWarnings.subscriber_id_mismatch)
    warnings.push("Subscriber ID mismatch across attachments");
  if (dataWarnings.patient_id_mismatch)
    warnings.push("Patient ID mismatch across attachments");
  return warnings;
};

/** 835s that may duplicate a manual payment (REV-2585). */
export const getPossibleDuplicatePayments = (
  dataWarnings: DataWarnings | null | undefined,
): PossibleDuplicatePayment[] => {
  const entries = dataWarnings?.possible_duplicate_payments;
  return Array.isArray(entries) ? entries : [];
};

export const formatDuplicatePaymentWarning = (count: number): string =>
  count === 1
    ? "Possible duplicate payment: an 835 may duplicate a manual payment"
    : `Possible duplicate payments: ${count} 835s may duplicate manual payments`;

/** Every warning as one sentence each, for a tooltip. */
export const getDataWarningMessages = (
  dataWarnings: DataWarnings | null | undefined,
): string[] => {
  const duplicates = getPossibleDuplicatePayments(dataWarnings).length;
  return [
    ...getMismatchWarnings(dataWarnings),
    ...(duplicates ? [formatDuplicatePaymentWarning(duplicates)] : []),
  ];
};
